import { LICENSING_ENDPOINT } from "Constants";
import { baseApi as api } from "Services";
import {
  CliUsageRequest,
  CliUsageResponse,
  CreateGroupUsageLimitRequest,
  DeleteGroupUsageLimitRequest,
  DeleteSiteKeyRequest,
  EditSiteKeyRequest,
  GetGroupsUsageRequest,
  GetGroupsUsageResponse,
  SubmitAllocationsRequest,
} from "../types";

export const licensingApi = api.injectEndpoints({
  endpoints: (build) => ({
    getGroupsUsage: build.query<GetGroupsUsageResponse, GetGroupsUsageRequest>({
      query: (queryArg) => ({
        url: `${LICENSING_ENDPOINT}/usage/groups/list`,
        params: {
          organization_id: queryArg.organizationId,
          group_name: queryArg.groupName,
          has_limit: queryArg.hasLimit,
          sort_by: queryArg.sortBy,
          limit: queryArg.limit,
          offset: queryArg.offset,
        },
      }),
      providesTags: ["Usage"],
    }),
    createGroupUsageLimit: build.mutation<void, CreateGroupUsageLimitRequest>({
      query: (queryArg) => ({
        url: `${LICENSING_ENDPOINT}/limits/groups`,
        method: "PUT",
        body: queryArg.body,
      }),
      invalidatesTags: ["Usage"],
    }),
    deleteGroupUsageLimit: build.mutation<void, DeleteGroupUsageLimitRequest>({
      query: (queryArg) => ({
        url: `${LICENSING_ENDPOINT}/limits/groups`,
        method: "DELETE",
        body: queryArg.body,
      }),
      invalidatesTags: ["Usage"],
    }),
    submitAllocations: build.mutation<void, SubmitAllocationsRequest>({
      query: (queryArg) => ({
        url: `${LICENSING_ENDPOINT}/allocations/submit`,
        method: "POST",
        body: queryArg.body,
      }),
      invalidatesTags: ["Usage", "SiteKeys"],
    }),
    getCliUsage: build.query<CliUsageResponse, CliUsageRequest>({
      query: (queryArg) => ({
        url: `${LICENSING_ENDPOINT}/usage/cli/list`,
        params: {
          organization_id: queryArg.organizationId,
          sort_by: queryArg.sortBy,
          offset: queryArg.offset,
          limit: queryArg.limit,
        },
      }),
      providesTags: ["SiteKeys"],
    }),
    editSiteKey: build.mutation<void, EditSiteKeyRequest>({
      query: (queryArg) => ({
        url: `${LICENSING_ENDPOINT}/limits/cli`,
        method: "PUT",
        body: queryArg,
      }),
      invalidatesTags: ["SiteKeys"],
    }),
    deleteSiteKey: build.mutation<void, DeleteSiteKeyRequest>({
      query: (queryArg) => ({
        url: `${LICENSING_ENDPOINT}/limits/cli`,
        method: "DELETE",
        body: queryArg,
      }),
      invalidatesTags: ["SiteKeys"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetGroupsUsageQuery,
  useCreateGroupUsageLimitMutation,
  useDeleteGroupUsageLimitMutation,
  useSubmitAllocationsMutation,
  useGetCliUsageQuery,
  useEditSiteKeyMutation,
  useDeleteSiteKeyMutation,
} = licensingApi;
